<ngx-codejar
  *ngIf="code"
  [highlightMethod]="highlightMethod"
  [code]="code"
  (mouseup)="mouseup()"
  (dragover)="$event.preventDefault()"
  #codejar
></ngx-codejar>
